<template>
  <div>
    <h3 class="fn-lg blue text-center spacing top md">手機號碼認證</h3>
    <div class="border bottom"></div>
    <h4 class="text-center spacing top md">您的手機號碼</h4>
    <h4 class="text-center spacing top sm bottom sm value fn-lg">{{ mobilePhone }}</h4>
    <h5 class="text-center">請查看您的手機簡訊，並將收到的驗證碼填入且送出，以完成手機驗證作業</h5>
    <form class="form_2R" name="step2-member-registration" @submit.prevent="verifyAndGetMemberRegistration">
      <div class="fieldset">
        <label class="fn-md">驗證碼</label>
        <input
          v-model.trim="authCode"
          type="text"
          class="form-control"
          placeholder="請輸入您的手機驗證碼"
          autocomplete="one-time-code"
          maxlength="10" />
        <a v-if="isShowCountdownBlock" class="divider text-muted text-center" href="javascript:void(0);">
          <time class="countdown">{{ secondsRemaining }}</time>
          秒後才能重新發送簡訊
        </a>
        <a
          v-else
          class="divider text-muted text-center btn-resend"
          href="javascript:void(0);"
          :disabled="isDisabledReVerifyOTPBtn"
          @click="fetchReVerifyOTP">
          重新發送驗證簡訊
        </a>
      </div>
      <p class="error notice" v-if="validateErrorMsg">
        {{ validateErrorMsg }}
      </p>
      <h5 class="divider horizontal">注意事項：</h5>
      <ol class="has-type-decimal sticky list-2R">
        <li>請確認手機號碼是否輸入正確，是否拒收企業廣告簡訊</li>
        <li>每日驗證碼最多申請 3 次</li>
        <li>驗證碼於發送後 5 分鐘後自動失效</li>
        <li>驗證成功系統將寄發預設密碼簡訊</li>
        <li>驗證碼輸入錯誤達 3 次上限，需重發驗證碼後再試</li>
      </ol>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-disabled btn-round"
          data-dismiss="modal"
          @click="$emit('cancel')"
          :disabled="isDisabledCancelOTPBtn">
          取消
        </button>
        <button type="submit" class="btn btn-query btn-round" :disabled="isDisabledVerifyOTPBtn">下一步</button>
      </div>
    </form>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { createRegistrationItem, sendGA4sEvent } from '@/helpers/tracking/ga';
import { getState, createComputed, commitMutation } from '@/helpers/vuex';
import { useVerifyOTP } from '@/composables/verifyOTP';
import { useRegister } from '@/composables/register';

export default {
  name: 'step2-member-registration',
  props: {
    mobilePhone: {
      type: String,
      default: '',
    },
  },
  computed: {
    authCode: createComputed('RegisterSenaoMembership', 'authCode'),
    validateErrorMsg: getState('RegisterSenaoMembership', 'validateErrorMsg'),
    isDisabledVerifyOTPBtn: createComputed('RegisterSenaoMembership', 'isDisabledVerifyOTPBtn'),
  },
  setup(props, context) {
    const {
      isDisabledCancelOTPBtn,
      isShowCountdownBlock,
      isDisabledReVerifyOTPBtn,
      startCountdown,
      secondsRemaining,
      fetchReVerifyOTP,
    } = useVerifyOTP();
    const { fetchRegister } = useRegister(props, context);

    onMounted(() => {
      startCountdown();
    });

    const verifyAndGetMemberRegistration = () => {
      const currentAuthCode = getState('RegisterSenaoMembership', 'authCode')();

      if (currentAuthCode === '') {
        commitMutation('RegisterSenaoMembership', 'validateErrorMsg', '請填寫正確的驗證碼');
        return;
      }
      sendGA4sEvent('sign_up_OTP', createRegistrationItem('簡訊驗證完成', 'cart'));
      fetchRegister();
    };

    return {
      fetchRegister,
      fetchReVerifyOTP,
      isDisabledCancelOTPBtn,
      isShowCountdownBlock,
      isDisabledReVerifyOTPBtn,
      secondsRemaining,
      startCountdown,
      verifyAndGetMemberRegistration,
    };
  },
};
</script>
